module.exports = __webpack_public_path__ + "img/Bookmark.d7553a52.svg";